import React, { memo, forwardRef } from "react";
const SvgReversibleReactionwithoverscript = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="#717171"
        fillRule="evenodd"
        d="M22.293 11.293a1 1 0 011.414 0l5 5a1 1 0 010 1.414l-5 5a1 1 0 01-1.414-1.414L25.586 18H12a1 1 0 110-2h13.586l-3.293-3.293a1 1 0 010-1.414zm-12.586 4a1 1 0 00-1.414 0l-5 5a1 1 0 000 1.414l5 5a1 1 0 001.414-1.414L6.414 22H20a1 1 0 100-2H6.414l3.293-3.293a1 1 0 000-1.414z"
        clipRule="evenodd"
      />
      <rect width={8} height={10} x={12} y={4} fill="#DBDBDB" rx={1} />
    </svg>
  );
});
SvgReversibleReactionwithoverscript.displayName =
  "SvgReversibleReactionwithoverscript";
const MemoForwardRef = memo(SvgReversibleReactionwithoverscript);
export default MemoForwardRef;
